import styles from '/src/assets/styles/pages/home.page.scss';

import { getSlider_req } from '../api/home.api';
import { getDeviceData, isClient } from '../helpers/detector.helper';
import { cacheControl } from '../helpers/cache.helper';
import { getGames_req } from '../api/game.api';

import HomeSection from '../components/sections/home/home.section';

export default function HomeWithCategoryPage({
  category,
  sliderData,
  games,
  providerId,
  providerName,
  page,
  gamesOnPage,
}) {
  return (
    <>
      <HomeSection
        page={page}
        gamesOnPage={gamesOnPage}
        category={category}
        sliderData={sliderData}
        games={games}
        providerId={providerId}
        providerName={providerName}
      />
      <style jsx>{styles}</style>
    </>
  );
}

HomeWithCategoryPage.getInitialProps = async ({
  res,
  req,
  query,
  reduxStore,
}) => {
  const { isMobile } = getDeviceData(req);

  const categoryName = query.category;
  const providerName = query.provider;
  const page = Number(query.page) || 1;
  const gamesOnPage = isMobile ? 30 : 36;

  const state = reduxStore.getState();

  const { categories, providers } = state.global;

  if (!isClient()) {
    cacheControl(res, 20);
  }

  let sliderData = null;
  let games = null;
  let providerId = null;

  if (!isClient() && req?.url && !req?.url.includes('/_next/')) {
    const categoryIndex = categories.findIndex(
      (category) => category.Key === categoryName
    );

    if (categoryIndex === -1) {
      res.writeHead(307, { Location: '/' });
      res.end();
      return;
    }

    const providerIndex = providers.findIndex(
      (provider) => provider.Name === providerName
    );
    if (providerIndex > -1) {
      providerId = providers[providerIndex].ID;
    }

    const categoryId = categories[categoryIndex].ID;

    try {
      sliderData = await getSlider_req({
        Key: 'home_slider',
        IsMobile: isMobile,
      });
    } catch (e) {
      console.log(
        'HomeWithCategoryPage -> getServerSideProps -> sliderData Error:',
        e
      );
    }

    try {
      games = await getGames_req(
        req.cookies,
        gamesOnPage,
        page,
        providerId,
        categoryId,
        null,
        isMobile
      );
    } catch (e) {
      console.log(
        'HomeWithCategoryPage -> getServerSideProps -> games Error:',
        e
      );
    }
  }

  // eslint-disable-next-line consistent-return
  return {
    gamesOnPage,
    category: categoryName,
    providerName,
    providerId,
    sliderData,
    games,
    page,
  };
};
